(function () {
  "use strict";

  var FALLBACK = "2026-08-04T19:00:00-04:00";
  var STORE_KEY = "lc_cd_confetti_fired";

  function pad(n) { return String(n).padStart(2, "0"); }

  function targetOf(root) {
    var raw = (root.getAttribute("data-target") || "").trim() || FALLBACK;
    var t = new Date(raw).getTime();
    // Guard a malformed/empty theme-editor value so we never render NaN.
    if (!isFinite(t)) t = new Date(FALLBACK).getTime();
    return t;
  }

  var roots = [].slice.call(document.querySelectorAll("[data-countdown]"));
  if (!roots.length) return;

  var reduce = false;
  try {
    reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {}

  /* ---------- confetti (iOS-style burst, single canvas, self-terminating) ---------- */

  function confetti() {
    if (reduce) return;
    if (document.querySelector(".cd-confetti")) return;

    var COLORS = ["#17b36a", "#ffd400", "#ff3b5c", "#4fc3f7", "#ffffff", "#ff8a3d"];
    var canvas = document.createElement("canvas");
    canvas.className = "cd-confetti";
    canvas.setAttribute("aria-hidden", "true");
    document.body.appendChild(canvas);

    var ctx = canvas.getContext("2d");
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w, h;

    function size() {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener("resize", size);

    var N = w < 640 ? 90 : 150;
    var bits = [];
    for (var i = 0; i < N; i++) {
      bits.push({
        x: w / 2 + (Math.random() - 0.5) * w * 0.5,
        y: h * 0.42 + (Math.random() - 0.5) * 60,
        vx: (Math.random() - 0.5) * 13,
        vy: Math.random() * -15 - 5,
        g: 0.32 + Math.random() * 0.16,
        s: 5 + Math.random() * 7,
        r: Math.random() * Math.PI * 2,
        vr: (Math.random() - 0.5) * 0.3,
        c: COLORS[(Math.random() * COLORS.length) | 0],
        sq: Math.random() > 0.35
      });
    }

    var start = performance.now();
    var LIFE = 4200;

    function frame(now) {
      var age = now - start;
      ctx.clearRect(0, 0, w, h);

      var alive = 0;
      for (var i = 0; i < bits.length; i++) {
        var b = bits[i];
        b.vy += b.g;
        b.vx *= 0.995;
        b.x += b.vx;
        b.y += b.vy;
        b.r += b.vr;

        if (b.y < h + 40) alive++;

        var fade = age > LIFE - 900 ? Math.max(0, (LIFE - age) / 900) : 1;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(b.x, b.y);
        ctx.rotate(b.r);
        ctx.fillStyle = b.c;
        if (b.sq) {
          ctx.fillRect(-b.s / 2, -b.s / 2, b.s, b.s * 0.62);
        } else {
          ctx.beginPath();
          ctx.arc(0, 0, b.s * 0.42, 0, Math.PI * 2);
          ctx.fill();
        }
        ctx.restore();
      }

      if (age < LIFE && alive > 0) {
        requestAnimationFrame(frame);
      } else {
        window.removeEventListener("resize", size);
        if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
      }
    }
    requestAnimationFrame(frame);
  }

  function fireOnce() {
    // Once per session, so navigating the site isn't a confetti loop.
    var fired = false;
    try { fired = sessionStorage.getItem(STORE_KEY) === "1"; } catch (e) {}
    if (fired) return;
    try { sessionStorage.setItem(STORE_KEY, "1"); } catch (e) {}
    confetti();
  }

  /* ---------- ticking ---------- */

  var timer = null;
  // Was every countdown already past at first paint? Then it's a normal
  // post-kickoff visit: show LIVE, no confetti.
  var armed = roots.some(function (r) { return targetOf(r) - Date.now() > 0; });

  function tick() {
    var pending = 0;

    roots.forEach(function (root) {
      var d = targetOf(root) - Date.now();

      if (d <= 0) {
        if (!root.classList.contains("is-live")) {
          root.classList.add("is-live");
          var live = root.querySelector("[data-cd-live]");
          if (live) live.hidden = false;
          var lbl = root.previousElementSibling;
          if (lbl && lbl.hasAttribute("data-cd-eyebrow")) lbl.hidden = true;
          // let the hero CTA row collapse onto one line once we're live
          if (root.closest) {
            var row = root.closest("[data-cta-row]");
            if (row) row.classList.add("is-live-row");
          }
          if (armed) fireOnce();
        }
        return;
      }

      pending++;
      var v = {
        days: Math.floor(d / 86400000),
        hours: Math.floor((d / 3600000) % 24),
        mins: Math.floor((d / 60000) % 60),
        secs: Math.floor((d / 1000) % 60)
      };
      Object.keys(v).forEach(function (k) {
        var el = root.querySelector('[data-cd="' + k + '"]');
        if (el) el.textContent = pad(v[k]);
      });
    });

    // Nothing left to count: stop the interval instead of burning a
    // timer forever rewriting the same zeros.
    if (!pending && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  tick();
  if (document.querySelector("[data-countdown]:not(.is-live)")) {
    timer = setInterval(tick, 1000);
  }

  // Device slept / tab backgrounded: resync immediately on return.
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) tick();
  });
})();
